import React from "react";

export default function StoryFilterChip({ emoji, isSelected, label, levelId, testId, onClick }) {
  return (
    <button aria-pressed={isSelected} className={`story-filter-chip${isSelected ? " selected" : ""}`} data-testid={testId} type="button" onClick={onClick}>
      {!!levelId && <span className={`story-level-dot ${levelId}`} />}
      {!!emoji && <span aria-hidden="true">{emoji}</span>}
      {label}
    </button>
  );
}
